import React, { useEffect, useState } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CNav,
    CNavItem,
    CNavLink,
    CForm,
    CFormInput,
    CFormLabel,
    CButton,
    CRow,
    CCol,
    CBadge,
    CAlert,
    CInputGroup,
    CInputGroupText,
} from '@coreui/react-pro';
import { useStore } from '../../contexts/StoreContext';
import * as DomicilappService from "../../services/DomicilappService";
import { ScheduleData } from '../../types/schedule';
import { useNotification } from '../../contexts/NotificationContext';

interface ScheduleRule {
    minimum_preparation_time: number;
    maximum_lead_days: number;
    number_simultaneous_orders: number;
}

export const StoreSchedulesPage: React.FC = () => {
    const { storeId } = useStore();
    const { showModal, showToast } = useNotification();

    const [activeTab, setActiveTab] = useState<'matrix' | 'rules'>('matrix');
    const [selectedDay, setSelectedDay] = useState<number>(1);

    const [rules, setRules] = useState<ScheduleRule>();
    // const [rules, setRules] = useState<ScheduleRule>({
    //     minimum_preparation_time: 10,
    //     maximum_lead_days: 5,
    //     number_simultaneous_orders: 5,
    // });

    const daysOfWeek = [
        { id: 1, key: 'lunes', label: 'Lunes' },
        { id: 2, key: 'martes', label: 'Martes' },
        { id: 3, key: 'miercoles', label: 'Miércoles' },
        { id: 4, key: 'jueves', label: 'Jueves' },
        { id: 5, key: 'viernes', label: 'Viernes' },
        { id: 6, key: 'sabado', label: 'Sábado' },
        { id: 7, key: 'domingo', label: 'Domingo' },
    ];

    const generateTimeSlots = () => {
        const slots = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let min of [0, 30]) {
                const hStr = hour.toString().padStart(2, '0');
                const mStr = min.toString().padStart(2, '0');
                slots.push(`${hStr}:${mStr}`);
            }
        }
        return slots;
    };


    // const [schedules, setSchedules] = useState<>(());
    const [schedules, setSchedules] = useState<ScheduleData[]>([]);

    const timeSlots = schedules.filter((sch) => sch.day_id === selectedDay);

    // const [schedules, setSchedules] = useState<Record<string, Record<string, boolean>>>(() => {
    // const initial: Record<string, Record<string, boolean>> = {};
    // daysOfWeek.forEach((day) => {
    //     initial[day.key] = {};
    //     timeSlots.forEach((slot) => {
    //         const hour = parseInt(slot.split(':')[0], 10);
    //         initial[day.key][slot] = hour >= 8 && hour < 20;
    //     });
    // });
    // return initial;
    // });

    useEffect(() => {
        if (!storeId) return;
        DomicilappService.getAllDeliverySchedulesByStore(storeId)
            .then((response: any) => setSchedules(response.data))
            .catch((err: any) => console.error('Error cargando el schedules', err));
    }, [storeId]);

    

    useEffect(() => {
        if (!storeId) return;
        DomicilappService.getAllDeliveryScheduleRulesByStore(storeId)
            .then((response: any) => setRules(response.data))
            .catch((err: any) => console.error('Error cargando el schedules', err));
    }, [storeId]);

    // useEffect(() => {
    //     console.log("------------------schedules------------------");
    //     console.log(schedules);
    // }, [schedules]);


    const toggleSlot = async (dayId: number, timeId: number) => {
        console.log("toggleSlot");
        console.log(dayId);
        console.log(timeId);
        let statusId;
        var resp = schedules.map((item) => {
            // Verificamos la condición: day_id === 1 y time_id === 1
            if (item.day_id === dayId && item.time_id === timeId) {
                console.log("Entra aqui");
                console.log(item);
                statusId = item.delivery_schedules_status_id == 1 ? 2 : 1;
                return {
                    ...item, // Copiamos todas las propiedades existentes
                    delivery_schedules_status_id: statusId // Sobrescribimos solo el status
                };
            }

            // Si no cumple la condición, devolvemos el objeto tal cual
            return item;
        });

        console.log("RESP");
        console.log(resp);

        setSchedules(resp);

        await DomicilappService.updateScheduleByStore(storeId, { schedules: [{ delivery_schedules_status_id: statusId, delivery_schedules_days_id: dayId, delivery_schedules_times_id: timeId }] });

    };



    const toggleAllDay = (dayId: number, active: boolean) => {
        // setSchedules((prev) => {
        //     const updatedDay: Record<string, boolean> = {};
        //     timeSlots.forEach((slot) => {
        //         updatedDay[slot] = active;
        //     });
        //     return { ...prev, [day]: updatedDay };
        // });
    };

    const getActiveSlotsCount = (dayId: number) => {
        return schedules.filter((sch) => sch.day_id === dayId).filter((stat) => stat.delivery_schedules_status_id === 1).length;
    };

    const updateRules = () => {
        console.log("updateRules");
        console.log(rules);
        if (rules) {
            DomicilappService.updateRulesByStore(storeId, rules).then((response) => {
                console.log(response);
                showToast({
                    title: '¡Operación Exitosa!',
                    message: 'Se actualizaron las reglas correctamente',
                    type: 'success', // 'success' | 'danger' | 'warning' | 'info' | 'brand'
                    delay: 3500,
                });
            })
        }
    };
    

    return (
        <CCard className="shadow-sm border-0 mb-4 bg-body rounded-3">
            <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0 fw-semibold text-body">
                        Gestión de Horarios y Capacidad
                    </h5>
                </div>
                <CNav variant="tabs" className="card-header-tabs border-0 mt-2">
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'matrix'}
                            onClick={() => setActiveTab('matrix')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'matrix'
                                ? 'text-body fw-bold border-bottom border-2 border-dark'
                                : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Horarios de Atención y Entrega
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'rules'}
                            onClick={() => setActiveTab('rules')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'rules'
                                ? 'text-body fw-bold border-bottom border-2 border-dark'
                                : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Capacidad y Tiempos de Preparación
                        </CNavLink>
                    </CNavItem>
                </CNav>
            </CCardHeader>

            <CCardBody className="p-4 bg-body text-body">
                {activeTab === 'matrix' && (
                    <>
                        <CAlert color="secondary" className="mb-4 border border-secondary-subtle text-body-secondary bg-body-tertiary small">
                            Activa o desactiva las franjas de 30 minutos en las que la tienda seleccionada recibirá y entregará pedidos. Los pedidos programados solo podrán agendarse en tus horas activas.
                        </CAlert>

                        <div className="d-flex flex-wrap gap-2 mb-4">
                            {daysOfWeek.map((day) => {
                                const activeCount = getActiveSlotsCount(day.id);
                                const isSelected = selectedDay === day.id;
                                return (
                                    <CButton
                                        key={day.key}
                                        color={isSelected ? 'dark' : 'light'}
                                        variant={isSelected ? undefined : 'ghost'}
                                        className={`flex-grow-1 py-2 rounded-2 d-flex flex-column align-items-center border ${isSelected ? 'border-dark' : 'border-secondary-subtle text-body'
                                            }`}
                                        onClick={() => setSelectedDay(day.id)}
                                    >
                                        <span className="small fw-semibold">{day.label}</span>
                                        <small className="mt-1">
                                            <CBadge
                                                color={activeCount > 0 ? 'secondary' : 'light'}
                                                className={`fw-normal ${activeCount > 0 ? 'text-white' : 'text-body-secondary border border-secondary-subtle'}`}
                                            >
                                                {activeCount > 0 ? `${(activeCount * 0.5).toFixed(1)} hrs` : 'Cerrado'}
                                            </CBadge>
                                        </small>
                                    </CButton>
                                );
                            })}
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 bg-body-tertiary p-3 rounded-2 border border-secondary-subtle">
                            <div>
                                <span className="small text-body-secondary text-uppercase fw-semibold">Día Seleccionado: </span>
                                <span className="fw-bold text-body text-uppercase ms-1">
                                    {daysOfWeek.find((d) => d.id === selectedDay)?.label}
                                </span>
                            </div>
                            {/* <div className="d-flex gap-2">
                                <CButton
                                    color="light"
                                    className="d-flex align-items-center gap-2 px-3 py-2 fw-medium border-0 shadow-sm text-body bg-body-tertiary"
                                    style={{ borderRadius: "8px" }}
                                    onClick={() => toggleAllDay(selectedDay, true)}
                                >

                                    <span>Activar Todo</span>
                                </CButton>
                                <CButton
                                    color="light"
                                    className="d-flex align-items-center gap-2 px-3 py-2 fw-medium border-0 shadow-sm text-body bg-body-tertiary"
                                    style={{ borderRadius: "8px" }}
                                    onClick={() => toggleAllDay(selectedDay, false)}
                                >

                                    <span>Desactivar Todo</span>
                                </CButton>
                            </div> */}
                        </div>

                        <CRow className="g-2 mb-4">
                            {timeSlots.map((slot) => {
                                const isActive = slot.delivery_schedules_status_id === 1;
                                return (
                                    <CCol key={slot.day_id+"-"+slot.time_id} xs={6} sm={4} md={3} lg={2}>
                                        <div
                                            onClick={() => toggleSlot(selectedDay, slot.time_id)}
                                            className={`p-2 text-center rounded-2 border transition-all ${isActive
                                                ? 'bg-dark text-white border-dark'
                                                : 'bg-body text-body-secondary border-secondary-subtle'
                                                }`}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                        >
                                            <div className="fw-semibold small">{slot.time.substring(0, 5)}</div>
                                            <small style={{ fontSize: '0.7rem' }} className={isActive ? 'text-white-50' : 'text-body-secondary'}>
                                                {isActive ? 'Abierto' : 'Cerrado'}
                                            </small>
                                        </div>
                                    </CCol>
                                );
                            })}
                        </CRow>
                    </>
                )}

                {activeTab === 'rules' && (
                    <CForm>
                        <CAlert color="secondary" className="mb-4 border border-secondary-subtle text-body-secondary bg-body-tertiary small">
                            Estas reglas controlan los algoritmos de asignación y disponibilidad para evitar la saturación en la cocina o punto de despacho de la tienda.
                        </CAlert>

                        <CRow className="g-4 mb-4">
                            <CCol md={4}>
                                <CCard className="h-100 border border-secondary-subtle shadow-none bg-body rounded-2">
                                    <CCardBody className="bg-body text-body">
                                        <h6 className="fw-semibold text-body mb-1">Tiempo Mínimo de Preparación</h6>
                                        <small className="text-body-secondary d-block mb-3">
                                            Tiempo estimado para tener listo un pedido antes de ser entregado o despachado.
                                        </small>
                                        <CFormLabel className="small text-body-secondary mb-1">Minutos requeridos</CFormLabel>
                                        <CInputGroup size="sm">
                                            <CFormInput
                                                type="number"
                                                className="bg-body text-body border-secondary-subtle"
                                                value={rules?.minimum_preparation_time}
                                                onChange={(e) =>
                                                    setRules({ ...rules!, minimum_preparation_time: Number(e.target.value) })
                                                }
                                            />
                                            <CInputGroupText className="bg-body-tertiary text-body-secondary border-secondary-subtle">min</CInputGroupText>
                                        </CInputGroup>
                                    </CCardBody>
                                </CCard>
                            </CCol>

                            <CCol md={4}>
                                <CCard className="h-100 border border-secondary-subtle shadow-none bg-body rounded-2">
                                    <CCardBody className="bg-body text-body">
                                        <h6 className="fw-semibold text-body mb-1">Máximo de Días de Anticipación</h6>
                                        <small className="text-body-secondary d-block mb-3">
                                            ¿Con cuántos días de anticipación puede un cliente programar un pedido?
                                        </small>
                                        <CFormLabel className="small text-body-secondary mb-1">Límite de días</CFormLabel>
                                        <CInputGroup size="sm">
                                            <CFormInput
                                                type="number"
                                                className="bg-body text-body border-secondary-subtle"
                                                value={rules?.maximum_lead_days}
                                                onChange={(e) =>
                                                    setRules({ ...rules!, maximum_lead_days: Number(e.target.value) })
                                                }
                                            />
                                            <CInputGroupText className="bg-body-tertiary text-body-secondary border-secondary-subtle">días</CInputGroupText>
                                        </CInputGroup>
                                    </CCardBody>
                                </CCard>
                            </CCol>

                            <CCol md={4}>
                                <CCard className="h-100 border border-secondary-subtle shadow-none bg-body rounded-2">
                                    <CCardBody className="bg-body text-body">
                                        <h6 className="fw-semibold text-body mb-1">Órdenes Simultáneas por Franja</h6>
                                        <small className="text-body-secondary d-block mb-3">
                                            Cantidad máxima de pedidos a procesar al mismo tiempo por bloque de 30 min.
                                        </small>
                                        <CFormLabel className="small text-body-secondary mb-1">Capacidad máxima</CFormLabel>
                                        <CInputGroup size="sm">
                                            <CFormInput
                                                type="number"
                                                className="bg-body text-body border-secondary-subtle"
                                                value={rules?.number_simultaneous_orders}
                                                onChange={(e) =>
                                                    setRules({ ...rules!, number_simultaneous_orders: Number(e.target.value) })
                                                }
                                            />
                                            <CInputGroupText className="bg-body-tertiary text-body-secondary border-secondary-subtle">pedidos</CInputGroupText>
                                        </CInputGroup>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>

                        <div className="d-flex justify-content-end">
                            <CButton
                            onClick={updateRules}
                                color="dark"
                                className="px-4 fw-medium text-white"
                            >
                                Guardar Reglas
                            </CButton>
                        </div>
                    </CForm>
                )}
            </CCardBody>
        </CCard>
    );
};

export default StoreSchedulesPage;